module.exports = __webpack_public_path__ + "img/sy_zxwd@3x.49c246ac.png";